<h3>{{title | translate}}</h3>
<app-dynamic-form [fields]="fields$ |async"></app-dynamic-form>